import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background-color: white;
  width: 90%;
  max-width: 400px;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  position: relative;

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #222;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 24px;
  height: 24px;

  &:hover svg {
    color: #333;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 140px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  resize: none;
  font-size: 16px;
  color: #333;
  margin-top: 5px;

  &::placeholder {
    color: #999;
    font-style: normal;
  }

  &:focus {
    outline: none;
    border-color: #ddd;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;

  button {
    min-height: 44px;
    min-width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    font-size: 16px;
    padding: 0;
    background-color: #cc2222 !important;
    border-color: #cc2222 !important;
    color: white !important;
    font-weight: bold;
  }
`;
